import APIUtils from '@spothero/utils/api';

const CreditCardAPI = {
    add({userId, stripeToken, isDefault}) {
        return APIUtils.post(`/users/${userId}/credit-cards/`, {
            stripe_token: stripeToken, // eslint-disable-line camelcase
            is_default: isDefault, // eslint-disable-line camelcase
        });
    },

    remove({userId, cardId}) {
        return APIUtils.delete(`/users/${userId}/credit-cards/${cardId}/`);
    },

    setAsDefault({userId, cardId, isDefault = true}) {
        return APIUtils.patch(
            `/users/${userId}/credit-cards/${cardId}/`,
            {
                is_default: isDefault, // eslint-disable-line camelcase
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
    },
};

export default CreditCardAPI;
